import { coreApi } from '@/api'

const toArray = value => (Array.isArray(value) ? value : []);
const toString = value => (value === null || value === undefined ? '' : String(value));

const Courses = {
  namespaced: true,
  state: {
    courses: [],
    employees: [],

    tests: [],
    materials: [],
  },
  actions: {
    async init({ dispatch }) {
      await dispatch('getEmployees');
      await dispatch('getCourses');
    },
    async getEmployees({ rootState, commit }) {
      let employees = await coreApi.employees(rootState.main.user.id);
      employees = toArray(employees);
      employees = employees.map((user) => {
        let initials = toString(user.name);
        initials = initials.split(' ').slice(0, 2).map((initial) => initial[0]?.toUpperCase())?.join('');
        return {
          ...user,
          initials,
        }
      });
      commit('setEmployees', employees);
    },
    async getCourses({ rootState, state, commit }) {
      let courses = await coreApi.courseList(rootState.main.user);
      courses = toArray(courses).map((course) => {
        const { employees, description, active } = course;
        const descriptionText = toString(description);
        
        return {
          ...course,
          active: active === '0' ? false : true,
          employees:
            toString(employees)
              .split('|')
              .filter((item) => item)
              .map((item) => state.employees
              .find(employee => employee.id == item))
              .filter((item) => item),
          desc: descriptionText.length > 10 ? `${descriptionText.slice(0, 75)}...` : descriptionText,
        };
      });

      commit('setCourses', courses);
    },

    // course
    async initCourse({ dispatch, state }, id) {
      if (!state.courses.length)
        await dispatch('init');

      await Promise.all([
        dispatch('getMaterial'),
        dispatch('getTests'),
      ]);

      if (id > 0) {
        const course = state.courses.find((course) => course.id == id);
        if (!course) return null;

        const structure = await dispatch('formirationStructure', course);

        return {
          ...course,
          structure,
        };
      }

      return {
        title: '',
        description: '',
        employees: [],
        structure: [],
        active: true,
      };
    },
    async formirationStructure({ state }, course) {
      let { structure } = course;
      if (structure) {
        const listEntity = structure.split(' | ');
  
        structure = listEntity.map((item) => {
          let itemFind = '';
          const itemCurrent = item.split(' - ');
  
          if (itemCurrent[1] === 'material') {
            itemFind = state.materials.find((item) => item.id === itemCurrent[0])
          } else {
            itemFind = state.tests.find((item) => item.id === itemCurrent[0])
          }
  
          return {
            ...itemFind,
            type: itemCurrent[1] === 'material' ? 'material' : 'test'
          }
        })

        return structure;
      }
      return [];
    },

    // meterial
    async getMaterial({ rootState, commit }) {
      commit('setMaterials', toArray(await coreApi.articleList(rootState.main.user)));
    },

    // test
    async getTests({ rootState, commit }) {
      commit('setTests', toArray(await coreApi.testList(rootState.main.user)));
    }
  },
  mutations: {
    setCourses(state, courses) {
      state.courses = courses;
    },
    setEmployees(state, employees) {
      state.employees = employees;
    },
    setMaterials(state, data) {
      state.materials = data;
    },
    setTests(state, data) {
      state.tests = data;
    },
  },
};

export default Courses;
